import { render, staticRenderFns } from "./aivideo.vue?vue&type=template&id=43ea55d1&scoped=true&"
import script from "./aivideo.vue?vue&type=script&lang=js&"
export * from "./aivideo.vue?vue&type=script&lang=js&"
import style0 from "./aivideo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./aivideo.vue?vue&type=style&index=1&id=43ea55d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ea55d1",
  null
  
)

export default component.exports